var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 1.875H20.0625V0H18.1875V1.875H5.8125V0H3.9375V1.875H2.8125C1.26169 1.875 0 3.13669 0 4.6875V21.1875C0 22.7383 1.26169 24 2.8125 24H21.1875C22.7383 24 24 22.7383 24 21.1875V4.6875C24 3.13669 22.7383 1.875 21.1875 1.875ZM22.125 21.1875C22.125 21.7044 21.7044 22.125 21.1875 22.125H2.8125C2.29556 22.125 1.875 21.7044 1.875 21.1875V8.8125H22.125V21.1875ZM22.125 6.9375H1.875V4.6875C1.875 4.17056 2.29556 3.75 2.8125 3.75H3.9375V5.625H5.8125V3.75H18.1875V5.625H20.0625V3.75H21.1875C21.7044 3.75 22.125 4.17056 22.125 4.6875V6.9375Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 10.7812H3.5625V12.6562H5.4375V10.7812Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 10.7812H7.3125V12.6562H9.1875V10.7812Z",
    fill: "#949494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 10.7812H11.0625V12.6562H12.9375V10.7812Z",
    fill: "#949494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 10.7812H14.8125V12.6562H16.6875V10.7812Z",
    fill: "#949494"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 10.7812H18.5625V12.6562H20.4375V10.7812Z",
    fill: "#949494"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 14.5312H3.5625V16.4062H5.4375V14.5312Z",
    fill: "#949494"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 14.5312H7.3125V16.4062H9.1875V14.5312Z",
    fill: "#949494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 14.5312H11.0625V16.4062H12.9375V14.5312Z",
    fill: "#949494"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 14.5312H14.8125V16.4062H16.6875V14.5312Z",
    fill: "#949494"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 18.2812H3.5625V20.1562H5.4375V18.2812Z",
    fill: "#949494"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 18.2812H7.3125V20.1562H9.1875V18.2812Z",
    fill: "#949494"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 18.2812H11.0625V20.1562H12.9375V18.2812Z",
    fill: "#949494"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 18.2812H14.8125V20.1562H16.6875V18.2812Z",
    fill: "#949494"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 14.5312H18.5625V16.4062H20.4375V14.5312Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/DateIcon.deb6da3f9c17ca76a4445349645456dc.svg";
export { ForwardRef as ReactComponent };